import './styles/index.less';
// import 'core-js/fn/date/now';
import 'core-js/fn/object/assign';
// import 'core-js/fn/string/trim';
import 'core-js/fn/promise';

import 'whatwg-fetch';

import CircleType from 'circletype';

require('jquery.marquee');



/*** PLAYER ***/

let player;
let playerControl;

function backgroundPlayer() {
    player = new ASVideoPlayer('as-video-player', (window.mainVideoID || 'd8DEBj7QRfetLsRgFnGEyg'), { autoplay: true, muted: true, ads: false });
    playerControl = player.getPlayer();

    playerControl.on('ready', function () {
        window.strSubSectionName = 'ASTV';
    });

    playerControl.on('touchend', onVideoBeginsFullScreen, false);
    playerControl.on('loadstart', loadstart, false); // necessary for starting with muted player

    $('.player-content').on('click', () => window.location.href = window.mainVideoLink);
}

function loadstart() {
    if ($('body').hasClass('focused')) {
        playerControl.muted(false);
    }
}

function onVideoBeginsFullScreen(e, state = false) {
    playerControl.muted(state);
}


/*** MARQUEE ***/

function marquee() {
    $(window).resize(() => {
        $('.ticker').marquee('destroy');

        initMarquee();
    });

    setTimeout(initMarquee, 1000);
}

function initMarquee() {
    $('.ticker').marquee({
        'startVisible': true,
        'allowCss3Support': false,
        'duration': ($(window).width() < 768) ? 7500 : 15000
    });
}



/*** NOTIFICATIONS ***/

var notifications = {};


function initNotifications() {
    setTimeout(checkLiveStreamNotifications, 7000);

    setTimeout(resizeNotification, 1000);
    $(window).resize(resizeNotification);

    $('.notifications .close').on('click', handleCloseNotification);
}

function resizeNotification() {
    if (window.innerWidth >= 1024) {
        $('.notifications').css({
            'left': $('.asnav-logo').offset().left,
            'width': $('.asnav-logo').outerWidth(),
            'top': (!$('.notifications').hasClass('showing')) ? $('.asnav-logo').offset().top - $('.notifications').height() : undefined
        })
    } else {
        $('.notifications').css({
            'left': 0,
            'width': '100%',
            'top': 'auto'
        })
    }
}

function checkLiveStreamNotifications() {
    $.ajax('/api/schedule/live', {
        success: function(res) {
            if (!res.data.started) {
                handleCloseNotification();
            }

            // the data has changed from previous values, so set the data, and update the content
            if (res.data.started !== notifications.started) {
                notifications = res.data;
                $('.notifications').addClass('showing');
                if (window.innerWidth >= 1024) $('.notifications').css('top', $('.asnav-logo').offset().top + $('.asnav-logo').height())
                updateLiveShow();
            }

            setTimeout(checkLiveStreamNotifications, 60000);
        }
    });
}

function updateLiveShow() {
    if (notifications.id) {
        $('.notifications .details h3').text(notifications.title);

        if (!notifications.isReplay) $('.notifications .details p').text('Streaming Live Now!');
        else $('.notifications .details p').text('Streaming Now');
    } else {
        $('.notifications .details h3').text('WMST');
        $('.notifications .details p').text('Streaming Now');
    }
}

function handleCloseNotification() {
    $('.notifications').removeClass('showing');
}


/*** NETBLOCK LISTENER ***/

function netblockListener() {
    // select the target node
    const target = document.getElementById('ad_bnr_atf_01');

    // create an observer instance
    const observer = new MutationObserver(function(mutations) {
        mutations.forEach(function(mutation) {
            if (mutation.type === 'childList') {
                setTimeout(function () {
                    const height = target.offsetHeight;
                    if (height >= 90) $('.player-wrapper').addClass('netblocked');
                }, 2000);
            }
        });
    });

    // configuration of the observer:
    const config = { attributes: true, childList: true, characterData: true };

    // pass in the target node, as well as the observer options
    observer.observe(target, config);
}

function getLiveShowThumbnails() {
    $('.fetch-image').each(function() {
        let $this = $(this);
        if ($this.attr('data-archive') !== '') {
            let collection_id = $(this).attr('data-archive');
            let searchURL = '/api/shows/v1/videos?q=collection_id:"' + collection_id + '"+AND+type:episode+AND+platforms:streams-archive&fields=poster,title,slug&sort=launch_date:desc&size=1';
            fetch(searchURL)
                .then(function(response) {
                    return response.json();
                }).then(function(json) {
                    const episode = json.data.videos[0];
                    const image = episode['poster'];

                    if (image) $this.find('img').attr('src', image);
                }).catch(function(err) {
                    console.warn('thumbnail not found', err);
                });
        }
    });
}


function featuresRollover() {
    $('.features .image').on('mouseenter', function() {
        const rolloverImage = $(this).data('rollover');
        $(this).find('img').attr('src', rolloverImage);
    })

    $('.features .image').on('mouseleave', function() {
        const originalImage = $(this).data('original');
        $(this).find('img').attr('src', originalImage);
    })
}


function circleType() {
    if (document.getElementById('play-text')) new CircleType(document.getElementById('play-text'));
}


/*** INITIALIZATION ***/

$(function () {

    backgroundPlayer();

    marquee();

    initNotifications();

    netblockListener();

    getLiveShowThumbnails();

    featuresRollover();

    circleType();

});






// WEBPACK FOOTER //
// ./src/client/index.js